<style scoped lang="scss">
.circle {
  border-radius: 100%;
  background-color: $danger;
  transition: background-color 0.3s linear;
  height: 25px;
  width: 25px;
  margin-left: 10px;

  &--online {
    background-color: $green;
  }

  .times-red {
    color: $red;
  }
}
</style>

<template>
  <td class="text-center text-lg">
    <div
      v-if="verified"
      class="circle"
      :class="{ 'circle--online': online }"
    ></div>
    <i v-else title="Nicht verifiziert" class="fas fa-times times-red"></i>
  </td>
</template>

<script lang="babel">
export default {
  props: ["model"],
  computed: {
    online() {
      return this.$store.getters["online/profileOnline"](this.model.id);
    },
    verified() {
      return this.model.user.email_verified_at !== null;
    }
  }
};
</script>
